"use client";

import { FC } from "react";

import { useRouter } from "next/navigation";

import { SearchBox as SearchBoxUI } from "@jti/ui/components/Search";

import { searchBoxInputs } from "./SearchBox.builder";

export type SearchBoxProps = BuilderComponentProps<typeof searchBoxInputs>;

export const SearchBox: FC<SearchBoxProps> = ({
  resultsPage,
  translations,
}) => {
  const { push } = useRouter();

  return (
    <SearchBoxUI
      resultsPage={resultsPage}
      translations={translations}
      navigationFn={(url: string) => push(url)}
    />
  );
};
